import React, { createContext, useContext, useMemo } from 'react';
import { ROLES } from '../constants/roles';

const UserRoleContext = createContext({
  role: null,
  /** True only when Firestore role is admin */
  isAdmin: false,
  uid: null,
  farmIds: [],
});

/**
 * Provides role + isAdmin for user-facing error messaging and admin-only console logs.
 * Wrap Layout (or any subtree that should know the signed-in user's role).
 */
export function UserRoleProvider({ role, uid, farmIds, children }) {
  const value = useMemo(
    () => ({
      role: role ?? null,
      isAdmin: role === ROLES.ADMIN,
      uid: uid ?? null,
      farmIds: Array.isArray(farmIds) ? farmIds : [],
    }),
    [role, uid, farmIds]
  );
  return <UserRoleContext.Provider value={value}>{children}</UserRoleContext.Provider>;
}

export function useUserRole() {
  return useContext(UserRoleContext);
}
